// MarketplaceHeroWidget — Position #1 gradient card per blueprint v6
// Sits ABOVE CityPro / FieldPro / Freedom Academy / Smart Health Tracker.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, ChevronRight, Sparkles } from 'lucide-react';
import api from '../utils/api';

const MarketplaceHeroWidget = () => {
  const [live, setLive] = useState(108);
  useEffect(() => {
    const tick = () => api.get('/marketplace/traffic').then((r) => setLive(r.data?.live || 108)).catch(() => {});
    tick();
    const t = setInterval(tick, 8000);
    return () => clearInterval(t);
  }, []);
  return (
    <section className="px-4 pt-4" data-testid="marketplace-hero-widget">
      <div className="max-w-7xl mx-auto">
        <Link to="/marketplace" className="block group">
          <div
            className="relative overflow-hidden rounded-3xl border shadow-2xl hover:scale-[1.005] transition-all min-h-[220px] sm:min-h-[260px]"
            style={{
              background: 'linear-gradient(135deg, #1E1B4B 0%, #4338CA 40%, #7C3AED 70%, #DB2777 100%)',
              borderColor: 'rgba(255,255,255,0.25)',
            }}
          >
            {/* animated glow */}
            <div className="absolute -top-16 -right-16 w-96 h-96 rounded-full bg-fuchsia-500/25 blur-3xl animate-pulse" />
            <div className="absolute -bottom-20 -left-20 w-96 h-96 rounded-full bg-indigo-500/25 blur-3xl" />
            {/* FEATURED ribbon */}
            <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-yellow-400 text-slate-900 text-[10px] font-black tracking-widest shadow-lg">⭐ FEATURED CORE ENGINE</div>

            <div className="relative p-5 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              <div className="flex-shrink-0 w-20 h-20 sm:w-28 sm:h-28 rounded-3xl bg-gradient-to-br from-yellow-400 via-pink-400 to-purple-500 border-4 border-white/40 shadow-2xl shadow-fuchsia-500/60 flex items-center justify-center text-5xl sm:text-7xl group-hover:rotate-6 group-hover:scale-110 transition-transform">
                🛒
              </div>
              <div className="flex-1 min-w-0 text-white">
                <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white/15 backdrop-blur border border-white/30 text-[10px] sm:text-xs font-black uppercase tracking-widest mb-2">
                  <Sparkles className="w-3 h-3" /> POWERED BY CITYPRO CONNECT
                </div>
                <h2 className="text-3xl sm:text-5xl font-black tracking-tight leading-none">
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-200 via-pink-200 to-fuchsia-200">Anant Smart</span>
                  <span className="text-white"> </span>
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-fuchsia-200 via-white to-yellow-200">Marketplace</span>
                </h2>
                <p className="text-sm sm:text-base opacity-90 mt-2 leading-relaxed">
                  Physical goods · Showrooms · Services — <b className="text-yellow-300">ek unified direct-trade hub</b>.
                  Har lead <b className="text-emerald-300">1-tap WhatsApp</b> pe, <b className="text-cyan-300">social share</b> built-in.
                </p>
                <div className="mt-3 flex items-center gap-2 flex-wrap">
                  <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-emerald-500/25 border border-emerald-400/60 text-[11px]" data-testid="mkt-hero-live">
                    <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" /> {live} Live Shoppers
                  </span>
                  <span className="text-[10px] px-2 py-1 rounded-lg bg-yellow-500/20 border border-yellow-400/40 font-black text-yellow-200">300 / 600 / 1500 AT Plans</span>
                  <span className="text-[10px] px-2 py-1 rounded-lg bg-fuchsia-500/20 border border-fuchsia-400/40 font-black text-fuchsia-200">Single Listing · 100 AT</span>
                </div>
              </div>
              <div className="hidden sm:flex flex-col items-end gap-2 shrink-0">
                <div className="inline-flex items-center gap-1 px-4 py-2.5 rounded-2xl bg-white text-purple-800 font-black text-sm shadow-xl group-hover:translate-x-1 transition">
                  <ShoppingBag className="w-4 h-4" /> Explore Marketplace <ChevronRight className="w-4 h-4" />
                </div>
                <div className="text-[10px] opacity-80">or list your item in 60 seconds</div>
              </div>
            </div>

            <div className="sm:hidden relative px-5 pb-5">
              <div className="w-full text-center px-4 py-3 rounded-2xl bg-white text-purple-800 font-black shadow-xl">
                🛒 Explore Marketplace →
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default MarketplaceHeroWidget;
